module.exports = __webpack_public_path__ + "static/img/fish14.d80aa45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish14.png
// module id = iUeh
// module chunks = 0